'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isFunction2 = _interopRequireDefault(require("lodash/isFunction"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames = _interopRequireDefault(require("classnames"));

var _grid = _interopRequireDefault(require("../grid"));

var _row = _interopRequireDefault(require("./row"));

var _default_row_renderer = _interopRequireDefault(require("./default_row_renderer"));

var _default_header_renderer = _interopRequireDefault(require("./default_header_renderer"));

var _reactStickynode = _interopRequireDefault(require("react-stickynode"));

var _reactDom = require("react-dom");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Table =
/*#__PURE__*/
function (_Component) {
  _inherits(Table, _Component);

  function Table(props) {
    var _this;

    _classCallCheck(this, Table);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Table).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "onUpdateScrollbarWidth", function (scrollbarWidth) {
      if (scrollbarWidth > 0) {
        var tableHeader = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this)).querySelector(".".concat(_this.props.headerClassName));

        if (tableHeader) {
          var paddingRight = window.getComputedStyle(tableHeader).getPropertyValue('padding-right');
          var totalPaddingRight = "".concat(scrollbarWidth + parseInt(paddingRight), "px");

          _this.setState({
            headerPaddingRight: totalPaddingRight
          });
        }
      } else {
        _this.setState({
          headerPaddingRight: null
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderRow", function (_ref) {
      var rowIndex = _ref.rowIndex;
      var _this$props = _this.props,
          children = _this$props.children,
          loading = _this$props.loading,
          rowClassName = _this$props.rowClassName,
          rowHeight = _this$props.rowHeight,
          maxVisibleColumns = _this$props.maxVisibleColumns,
          scrolledColumns = _this$props.scrolledColumns,
          sortBy = _this$props.sortBy,
          rowGetter = _this$props.rowGetter,
          defaultRowRenderer = _this$props.defaultRowRenderer,
          onRowClick = _this$props.onRowClick,
          onRowDoubleClick = _this$props.onRowDoubleClick,
          onRowMouseOver = _this$props.onRowMouseOver,
          onRowMouseOut = _this$props.onRowMouseOut,
          onRowMouseEnter = _this$props.onRowMouseEnter,
          onRowMouseLeave = _this$props.onRowMouseLeave;
      var rowData = rowGetter({
        index: rowIndex
      });
      var className = (0, _isFunction2["default"])(rowClassName) ? rowClassName({
        index: rowIndex,
        rowData: rowData
      }) : rowClassName;

      var columns = _react["default"].Children.toArray(children);

      return _react["default"].createElement(_row["default"], {
        key: rowIndex,
        loading: loading,
        rowRenderer: defaultRowRenderer,
        rowClassName: className,
        rowData: rowData,
        rowIndex: rowIndex,
        rowHeight: rowHeight,
        columns: columns,
        maxVisibleColumns: maxVisibleColumns,
        scrolledColumns: scrolledColumns,
        sortBy: sortBy,
        onClick: onRowClick,
        onDoubleClick: onRowDoubleClick,
        onMouseOver: onRowMouseOver,
        onMouseOut: onRowMouseOut,
        onMouseEnter: onRowMouseEnter,
        onMouseLeave: onRowMouseLeave
      });
    });

    _this.state = {
      headerPaddingRight: null
    };
    return _this;
  }
  /**
   * Calculates the header's total right padding if container has overflow and a scrollbar exists and
   * automatically sets the header right padding to include the scrollbar width PLUS any existing padding
   * in order for the column headers to be aligned with the table rows content.
   */


  _createClass(Table, [{
    key: "getGridHeight",
    value: function getGridHeight() {
      if (this.props.useWindow) {
        return 0;
      } else {
        return this.props.height - this.props.headerHeight;
      }
    }
  }, {
    key: "renderHeader",
    value: function renderHeader() {
      var _this$props2 = this.props,
          loading = _this$props2.loading,
          children = _this$props2.children,
          rowCount = _this$props2.rowCount,
          useWindow = _this$props2.useWindow,
          stickyHeader = _this$props2.stickyHeader,
          headerHeight = _this$props2.headerHeight,
          showHeaderAlways = _this$props2.showHeaderAlways;

      if (loading || rowCount > 0 || showHeaderAlways) {
        var columns = _react["default"].Children.toArray(children);

        var stickyProps = _objectSpread({}, stickyHeader, {
          enabled: useWindow
        });

        var headerRenderer = (0, _isFunction2["default"])(this.props.defaultHeaderRenderer) ? this.props.defaultHeaderRenderer : _default_header_renderer["default"];
        var style = {
          paddingRight: this.state.headerPaddingRight
        };
        return _react["default"].createElement(_reactStickynode["default"], _extends({}, stickyProps, {
          className: "table-header-wrapper"
        }), headerRenderer(_objectSpread({}, this.props, {}, {
          columns: columns,
          style: style,
          className: this.props.headerClassName,
          height: headerHeight
        })));
      }
    }
  }, {
    key: "renderTableList",
    value: function renderTableList() {
      if (!this.props.loading && this.props.rowCount === 0) {
        return _react["default"].createElement("div", {
          className: "table-list empty"
        }, this.props.noRows);
      } else {
        return _react["default"].createElement(_grid["default"], {
          className: "table-list",
          rowCount: this.props.rowCount,
          rowHeight: this.props.rowHeight,
          renderRow: this.renderRow,
          loading: this.props.loading,
          height: this.getGridHeight(),
          useWindow: this.props.useWindow,
          onUpdateScrollbarWidth: this.onUpdateScrollbarWidth
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var outerClassName = (0, _classnames["default"])('virtual-table', 'table', this.props.className, {
        loading: this.props.loading
      });
      return _react["default"].createElement("div", {
        id: this.props.id,
        className: outerClassName
      }, this.renderHeader(), this.renderTableList());
    }
  }]);

  return Table;
}(_react.Component);

_defineProperty(Table, "propTypes", {
  defaultRowRenderer: _propTypes.PropTypes.func.isRequired,
  defaultHeaderRenderer: _propTypes.PropTypes.func.isRequired,
  rowCount: _propTypes.PropTypes.number.isRequired,
  rowGetter: _propTypes.PropTypes.func.isRequired,
  rowHeight: _propTypes.PropTypes.number.isRequired,
  headerHeight: _propTypes.PropTypes.number.isRequired,
  height: _propTypes.PropTypes.number.isRequired,
  rowClassName: _propTypes.PropTypes.oneOfType([_propTypes.PropTypes.string, _propTypes.PropTypes.func]),
  onSort: _propTypes.PropTypes.func,
  sortBy: _propTypes.PropTypes.string,
  sortDirection: _propTypes.PropTypes.string,
  onRowClick: _propTypes.PropTypes.func,
  onRowDoubleClick: _propTypes.PropTypes.func,
  onRowMouseOver: _propTypes.PropTypes.func,
  onRowMouseOut: _propTypes.PropTypes.func,
  onRowMouseEnter: _propTypes.PropTypes.func,
  onRowMouseLeave: _propTypes.PropTypes.func,
  stickyHeader: _propTypes.PropTypes.object,
  noRows: _propTypes.PropTypes.object,
  loading: _propTypes.PropTypes.bool,
  showHeaderAlways: _propTypes.PropTypes.bool,
  maxVisibleColumns: _propTypes.PropTypes.number,
  scrolledColumns: _propTypes.PropTypes.number,
  useWindow: _propTypes.PropTypes.bool
});

_defineProperty(Table, "defaultProps", {
  defaultRowRenderer: _default_row_renderer["default"],
  defaultHeaderRenderer: _default_header_renderer["default"],
  loading: false,
  scrolledColumns: 0,
  noRows: _react["default"].createElement("span", null, "No data available"),
  showHeaderAlways: false,
  height: 0,
  useWindow: false,
  headerClassName: 'table-header',
  onRowClick: function onRowClick() {},
  onRowDoubleClick: function onRowDoubleClick() {},
  onRowMouseOver: function onRowMouseOver() {},
  onRowMouseOut: function onRowMouseOut() {},
  onScrollHeader: function onScrollHeader() {},
  onSort: function onSort() {}
});

var _default = Table;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@rapiddot/react-virtual-list/lib/table/index.js
// module id = 477
// module chunks = 0